// contexts/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // { id, role, roleStudent, roleWriter, roleSupport, roleAdmin }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = () => {
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
      }
      setLoading(false);
    };
    initializeAuth();
  }, []);

  const login = async ({ email, password }) => {
    if (!email || !password) throw new Error("Email and password are required");

    const response = await fetch("/api/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "login", email, password }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(errorData.error || "Login failed");
      error.type = errorData.error === "Invalid email or password" ? "invalidCredentials" : "generalError";
      throw error;
    }

    const data = await response.json();
    if (!data.userId || (!data.roleStudent && !data.roleWriter && !data.roleSupport && !data.roleAdmin)) {
      throw new Error("Invalid user data from API");
    }

    const userData = {
      id: data.userId,
      role: data.roleAdmin ? "admin" : data.roleSupport ? "support" : data.roleWriter ? "writer" : "student",
      roleStudent: data.roleStudent || false,
      roleWriter: data.roleWriter || false,
      roleSupport: data.roleSupport || false,
      roleAdmin: data.roleAdmin || false,
    };

    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const value = { user, loading, login, logout };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};